import { useEffect, useState } from 'react';
import { Badge } from './ui/badge';
import { Lightbulb, X } from 'lucide-react';
import api from '../utils/api';

export function DailyTipCard() {
  const [tip, setTip] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    const fetchTip = async () => {
      try {
        const res = await api.get('/daily-tip');
        setTip(res.data);
      } catch (err) {
        console.warn('Daily tip fetch failed:', err);
      }
    };
    fetchTip();
  }, []);
  if (!tip || dismissed) return null;
  return (
    <div className="mb-6 relative group" data-testid="daily-tip-card">
      <div className="rounded-xl border border-[#5B6FD6]/15 bg-gradient-to-r from-[#5B6FD6]/5 via-white to-[#10B981]/5 p-4 flex items-start gap-4">
        <div className="h-10 w-10 rounded-lg bg-gradient-to-br from-[#5B6FD6] to-[#10B981] flex items-center justify-center flex-shrink-0 shadow-sm">
          <Lightbulb className="h-5 w-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-semibold text-[#5B6FD6] uppercase tracking-wide">Tip of the Day</span>
            <Badge variant="outline" className="text-[10px] px-1.5 py-0 text-slate-500 border-slate-200">{tip.category}</Badge>
          </div>
          <p className="text-sm text-slate-700 leading-relaxed">{tip.tip}</p>
        </div>
        <button onClick={() => setDismissed(true)} className="p-1 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors opacity-0 group-hover:opacity-100 flex-shrink-0" data-testid="dismiss-tip-btn">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
